/**
 * Lightweight heuristic: whether the text likely contains Markdown worth previewing.
 * @param {string} text
 */
export function looksLikeMarkdown(text) {
  if (!text || typeof text !== 'string') {
    return false;
  }
  const t = text;
  if (t.trim().length < 3) {
    return false;
  }

  const signals = [
    /(?:^|\n)#{1,6}\s\S/,
    /\*\*[^*\n]+?\*\*/,
    /__[^_\n]+?__/,
    /`{3}/,
    /`[^`\n]{1,200}`/,
    /(?:^|\n)\s{0,3}[-*+]\s+\S/m,
    /(?:^|\n)\s{0,3}\d+\.\s+\S/m,
    /(?:^|\n)>\s\S/m,
    /\[[^\]\n]+\]\([^)\s]+\)/,
    /(?:^|\n)[ \t]*\|[^|\n]+\|/m,
    /^[ \t]*[*_\-]{3,}[ \t]*$/m,
  ];

  return signals.some((re) => re.test(t));
}
